/** @jsxImportSource @emotion/react */
import PropTypes from "prop-types";
import Popper from "components/common/Popper";
import { ReactComponent as InfoIcon } from "assets/icons/InformationHeader.svg";
import { columnGap4Css } from "assets/css/gaps.css";
import { labelCss } from "assets/css/fieldset.css";
import { iconCss } from "./index.css";

export default function Label({ label, inputId, popperText }) {
  if (!label) {
    return null;
  }

  if (popperText) {
    return (
      <div className="flex-a-c-j-st" css={columnGap4Css}>
        <label htmlFor={inputId} css={labelCss}>
          {label}
        </label>

        <Popper text={popperText} placement="top">
          <InfoIcon css={iconCss} />
        </Popper>
      </div>
    );
  }

  return (
    <label htmlFor={inputId} className="main-text-grey-bold">
      {label}
    </label>
  );
}

Label.propTypes = {
  label: PropTypes.string,
  inputId: PropTypes.string,
  popperText: PropTypes.string,
};
